import { AfterViewInit, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes/component/devices.class';
import { GalleryDataModel } from '@app/core/models/gallery';
declare var $;
// import 'slick-carousel/slick/slick.js';

@Component({
  selector: 'shared-partners',
  templateUrl: 'partners.component.html',
  styleUrls: [`./partners.component.scss`],
})

export class PartnersComponent extends DevicesClass implements OnInit, AfterViewInit {
  public PartnersGalleryData: GalleryDataModel = this.onPartnersGalleryData();

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    /**
     * Hook of Slick plugin.
     * Fix after added more 4 partners.
     */
    this.PartnersGalleryData.map(item => this.PartnersGalleryData.push(item));
  }

  ngAfterViewInit(): void {
    /**
     * Hook of Slick plugin init.
     */
    setTimeout(() => this.onPartnersGalleryFn(), 100)
  }

  onPartnersGalleryFn(): void {
    if (typeof $ === 'function') {
      try {
        $('.footer-partners__slide').slick({
          autoplay: true,
          infinite: true,
          dots: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      } catch (e) {}
    }
  }

  onPartnersGalleryData(): GalleryDataModel {
    return [
      {
        picture: 'assets/images/partners/gibson.png',
        url: '',
        title: ''
      },
      {
        picture: 'assets/images/partners/mm.png',
        url: '',
        title: ''
      },
      {
        picture: 'assets/images/partners/gl.png',
        url: '',
        title: ''
      },
      {
        picture: 'assets/images/partners/chayka.png',
        url: '',
        title: ''
      }
    ]
  }
}
